export default () => ({
  chats: [],
  hasError: false,
  notifiableChatMessages: [],
})
